import React, { useMemo } from "react"
import { Card, CardBody, CardTitle, Badge } from "reactstrap"
import { useGetAllProjectsQuery } from "store/features/client/clientManagementApi"
import { useGetAllUsersQuery } from "store/features/users/userManagementApi"

const OngoingProjects = () => {
  const { data: projects = [] } = useGetAllProjectsQuery()
  const { data: users = [] } = useGetAllUsersQuery()

  // Filter ongoing projects (In Progress status)
  const ongoingProjects = useMemo(() => {
    return projects.filter(project => project.status === "In Progress")
  }, [projects])

  // Get user by ID
  const getUserById = userId => {
    return users.find(user => user.id === userId)
  }

  // Get role display name
  const getRoleDisplayName = role => {
    const roleNames = {
      project_manager: "Project Manager",
      developer: "Developer",
      designer: "Designer",
      super_admin: "Super Admin",
      admin: "Admin",
      marketing: "Marketing",
    }
    return roleNames[role] || role
  }

  return (
    <Card className="dashboard-card">
      <CardBody>
        <CardTitle tag="h5" className="mb-3">
          Ongoing Projects
          <Badge color="primary" className="ms-2">
            {ongoingProjects.length}
          </Badge>
        </CardTitle>

        {ongoingProjects.length === 0 ? (
          <div className="text-center py-4">
            <i className="fas fa-briefcase fa-2x text-muted mb-2"></i>
            <p className="text-muted mb-0">No ongoing projects</p>
          </div>
        ) : (
          <div className="ongoing-projects-list">
            {ongoingProjects.map(project => (
              <div
                key={project.id}
                className="project-item mb-3 p-3 border rounded"
              >
                {/* Project Name and Progress */}
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <a href={`/projects/${project?.id}`}>
                    <h6 className="mb-0 text-primary fs-5">{project.name}</h6>
                  </a>
                  <Badge color="info">{project.progress || 0}%</Badge>
                </div>

                {/* Project Manager */}
                {project.assigned_project_manager &&
                  project.assigned_project_manager.length > 0 && (
                    <div className="d-flex gap-2">
                      <p className="text-muted mb-0">Project Manager:</p>
                      <div className="d-flex">
                        {project.assigned_project_manager.map(
                          (managerId, i) => {
                            const manager = getUserById(managerId)
                            return manager ? (
                              // <Badge
                              //   key={managerId}
                              //   color="primary"
                              //   className="me-1 mb-1"
                              // >
                              //   {manager.nickname} (
                              //   {getRoleDisplayName(manager.role)})
                              // </Badge>

                              <p className="text-primary mb-0 me-2">
                                {i + 1}. {manager.nickname}
                              </p>
                            ) : null
                          }
                        )}
                      </div>
                    </div>
                  )}

                {/* Frontend Developers */}
                {project.assigned_frontend_dev &&
                  project.assigned_frontend_dev.length > 0 && (
                    <div className="d-flex gap-2">
                      <p className="text-muted mb-0">Frontend Developers:</p>
                      <div className="d-flex">
                        {project.assigned_frontend_dev.map((devId, i) => {
                          const developer = getUserById(devId)
                          return developer ? (
                            // <Badge
                            //   key={devId}
                            //   color="success"
                            //   className="me-1 mb-1"
                            // >
                            //   {developer.nickname} (
                            //   {getRoleDisplayName(developer.role)})
                            // </Badge>
                            <p className="text-success mb-0 me-2">
                              {i + 1}. {developer.nickname}
                            </p>
                          ) : null
                        })}
                      </div>
                    </div>
                  )}

                {/* Backend Developers */}
                {project.assigned_backend_dev &&
                  project.assigned_backend_dev.length > 0 && (
                    <div className="d-flex gap-2">
                      <p className="text-muted mb-0">Backend Developers:</p>
                      <div className="d-flex">
                        {project.assigned_backend_dev.map((devId, i) => {
                          const developer = getUserById(devId)
                          return developer ? (
                            // <Badge
                            //   key={devId}
                            //   color="warning"
                            //   className="me-1 mb-1"
                            // >
                            //   {developer.nickname} (
                            //   {getRoleDisplayName(developer.role)})
                            // </Badge>

                            <p className="text-warning mb-0 me-2">
                              {i + 1}. {developer.nickname}
                            </p>
                          ) : null
                        })}
                      </div>
                    </div>
                  )}

                {/* Designers */}
                {project.assigned_designer &&
                  project.assigned_designer.length > 0 && (
                    <div className="d-flex gap-2">
                      <p className="text-muted mb-0">Designers:</p>
                      <div className="d-flex">
                        {project.assigned_designer.map((designerId, i) => {
                          const designer = getUserById(designerId)
                          return designer ? (
                            // <Badge
                            //   key={designerId}
                            //   color="info"
                            //   className="me-1 mb-1"
                            // >
                            //   {designer.nickname} (
                            //   {getRoleDisplayName(designer.role)})
                            // </Badge>

                            <p className="text-info mb-0 me-2">
                              {i + 1}. {designer.nickname}
                            </p>
                          ) : null
                        })}
                      </div>
                    </div>
                  )}

                {/* No Team Assigned */}
                {(!project.assigned_project_manager ||
                  project.assigned_project_manager.length === 0) &&
                  (!project.assigned_frontend_dev ||
                    project.assigned_frontend_dev.length === 0) &&
                  (!project.assigned_backend_dev ||
                    project.assigned_backend_dev.length === 0) &&
                  (!project.assigned_designer ||
                    project.assigned_designer.length === 0) && (
                    <div className="text-center">
                      <Badge color="secondary">No team assigned</Badge>
                    </div>
                  )}

                {/* Project Info Footer */}
                {/* <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                  <small className="text-muted">
                    Budget: ${parseFloat(project.budget || 0).toLocaleString()}
                  </small>
                  <small className="text-muted">
                    {project.start_date
                      ? new Date(project.start_date).toLocaleDateString()
                      : "No start date"}
                  </small>
                </div> */}
              </div>
            ))}
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default OngoingProjects
